import classNames from 'classnames';
import React from 'react';
import Modal, { ModalProps } from 'rsuite/lib/Modal';
import { ReactComponent as CheckCircleIcon } from '../../../../../../assets/icons/loader #3.svg';
import { ButtonPrimary } from '../../../../../../components';
import { LoadingSpinerArea } from '../../../../../../components/LoadingSpinner';
import styles from './FecharNegocioModal.module.scss';

export type FecharNegocioModalDataProps = {
  name: string;
  id: string;
};

export type FecharNegocioModalProps = ModalProps & {
  data: FecharNegocioModalDataProps;
  onSubmit?: (formData: FecharNegocioModalDataProps) => void;
  onHide?: () => void;
};

export const FecharNegocioModalModal = ({ className = '', onHide, onSubmit, data, ...props }: FecharNegocioModalProps) => (
  <>
    <Modal className={classNames('info-modal', styles['fechar-negocio-modal'], className)} onHide={onHide} {...props}>
      <LoadingSpinerArea height="100%" size="md" area="negotiation/close-negotiation" />
      <form onSubmit={e => e.preventDefault()}>
        <Modal.Header className={styles['fechar-negocio-modal__header']}>
          <div className={styles['fechar-negocio-modal__icon-container']}>
            <div className={styles['fechar-negocio-modal__icon']}>
              <CheckCircleIcon />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className={styles['fechar-negocio-modal__body']}>
          <Modal.Title className={styles['fechar-negocio-modal__title']}>Fechar negócio</Modal.Title>
          <div className={styles['fechar-negocio-modal__message']}>
            <p className={styles['fechar-negocio-modal__message-text']}>
              Ao prosseguir, todos os preços com status de aprovado ou reprovado serão mantidos. Os preços que ainda não têm aprovação serão automaticamente
              aprovados.
            </p>
            <p className={styles['fechar-negocio-modal__message-text--bold']}>
              Para reprovar ou excluir qualquer preço, faça a alteração antes de fechar o negócio.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles['fechar-negocio-modal__footer']}>
          <ButtonPrimary skin="blue" theme="ghost" type="button" onClick={onHide}>
            CANCELAR
          </ButtonPrimary>
          <ButtonPrimary skin="blue" theme="filled" type="submit" onClick={() => onSubmit?.(data)}>
            FECHAR NEGÓCIO
          </ButtonPrimary>
        </Modal.Footer>
      </form>
    </Modal>
    <LoadingSpinerArea size="sm" area="saved-filter" />
  </>
);
